import React from "react";

export default function CanYouBelieve() {
  return (
    <>
      <section
        className="clients-section alternat-2 p_30 centred"
        style={{ backgroundColor: "#071522" }}
      >
        <div className="auto-container">
          <div className="inner-container">
            <h1 className="text-white">
              Unlock the Potential of Blockchain with Our Expert Solutions
            </h1>
            <p className="text-white py-3">
              Xeer Technology specializes in comprehensive Crypto Coin and Token
              Development Services designed to help businesses and entrepreneurs
              harness the power of blockchain technology. Whether you need a
              unique cryptocurrency or a specialized token, our team of
              experienced developers is here to guide you through the entire
              process.
            </p>
          </div>
          <a href="/contact-us" className="theme-btn btn-one mr_20">
            Get a quote
          </a>
        </div>
      </section>
    </>
  );
}
